import axios from "axios";

import { adminUrl, PAGES } from "../config/constants";

export const checkEmail = (values) => async (dispatch, getState) => {
  dispatch({
    type: "SET_LOADING",
    payload: true,
  });

  dispatch({
    type: "SET_FORM_CONTACTS",
    payload: values,
  });

  dispatch({
    type: "SET_FORM_ERROR",
    payload: false,
  });

  const formData = new FormData();

  formData.append("action", "checkEmailBorrower");
  formData.append("email", values.email);

  const { data } = await axios.post(adminUrl, formData);

  dispatch({
    type: "SET_LOADING",
    payload: false,
  });

  if (data.result === 1 && data.data.pms_password !== "") {
    // user have already password let the user login
    dispatch({
      type: "SET_FORM_ERROR",
      payload: true,
    });

    return;
  }

  let payload = {};

  if (data.result === 0) {
    payload = {
      isNewUser: true,
    };
  } else if (data.result === 1 && data.data.pms_password === "") {
    payload = {
      userId: data.data.id,
    };
  }

  //  IF borrower

  dispatch({
    type: "SET_USER",
    payload: payload,
  });

  dispatch({
    type: "SET_PAGE",
    payload: PAGES.PASSWORD_SCREEN,
  });

  // check for emial add of contacts
};



// WEBPACK FOOTER //
// ./src/actions/checkEmail.actions.js